import React from 'react';
import { Navigate } from 'react-router-dom';
import TrackerLayout from '../components/TrackerLayout';
import LeavePanel from '../components/LeavePanel';
import { useTracker } from '../context/TrackerContext';

// Mentors and Student Coordinators apply for leave here; salespeople do the
// same from the Leave tab on their dashboard.
const MyLeave: React.FC = () => {
  const { session } = useTracker();
  if (!session || (session.kind !== 'mentor' && session.kind !== 'coordinator')) {
    return <Navigate to="/tracker/mentor/login" replace />;
  }

  return (
    <TrackerLayout>
      <div className="space-y-5">
        <div className="rounded-2xl overflow-hidden shadow-lg"
          style={{ background: 'linear-gradient(135deg,#2b2240 0%,#3d2f5f 50%,#2b2240 100%)' }}>
          <div className="px-6 py-5">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-2xl">🌴</span>
              <h1 className="text-xl font-bold text-white">My Leave</h1>
            </div>
            <p className="text-white/50 text-xs">Apply for leave and track it — admin approves each request</p>
          </div>
        </div>
        <LeavePanel employeeType="mentor" employeeId={session.mentorId} />
      </div>
    </TrackerLayout>
  );
};

export default MyLeave;
